import { render, staticRenderFns } from "./vFormPART_LEGEND.vue?vue&type=template&id=3eff5244&"
import script from "./vFormPART_LEGEND.vue?vue&type=script&lang=js&"
export * from "./vFormPART_LEGEND.vue?vue&type=script&lang=js&"
import style0 from "./vFormPART_LEGEND.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports